import { useAgendaSettingsContext } from './Context';

type ToggleRowProps = {
    title: string;
    description?: string;
    checked: boolean;
    onChange: (value: boolean) => void;
    disabled?: boolean;
};

const ToggleRow = ({ title, description, checked, onChange, disabled }: ToggleRowProps) => (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="space-y-1">
            <div className="text-sm font-medium text-base-content">{title}</div>
            {description && <div className="text-xs text-base-content/60">{description}</div>}
        </div>
        <input
            type="checkbox"
            className="toggle toggle-primary"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled}
        />
    </div>
);

export const PermissionsSchedule = () => {
    const {
        minutesBeforeConfirmation,
        setMinutesBeforeConfirmation,
        requireConfirmation,
        setRequireConfirmation,
        setSendWhatsapp,
        sendWhatsapp,
        submitAdm,
        loading,
        allowCancellation,
        setAllowCancellation,
        minutesBeforeCancellation,
        setMinutesBeforeCancellation,
        canEditAgendaSettings,
    } = useAgendaSettingsContext();

    return (
        <div className="w-full space-y-4">
            <div className="rounded-xl border border-base-200 bg-base-100 p-4 space-y-4">
                <ToggleRow
                    title="Permitir que o cliente cancele o agendamento?"
                    description="Define se o cliente pode cancelar dentro de um prazo limite."
                    checked={allowCancellation}
                    onChange={setAllowCancellation}
                    disabled={!canEditAgendaSettings}
                />

                {allowCancellation && (
                    <div className="space-y-2">
                        <label className="label" htmlFor="minutesBeforeCancellation">
                            <span className="label-text">Quantos minutos antes o cliente pode cancelar?</span>
                        </label>
                        <input
                            type="number"
                            id="minutesBeforeCancellation"
                            value={minutesBeforeCancellation}
                            onChange={(e) => setMinutesBeforeCancellation(parseInt(e.target.value))}
                            className="input input-bordered w-full"
                            min="1"
                            disabled={!canEditAgendaSettings}
                        />
                        <div className="text-xs text-base-content/60">
                            Ex.: 120 permite cancelar até 2 horas antes.
                        </div>
                    </div>
                )}
            </div>

            <div className="rounded-xl border border-base-200 bg-base-100 p-4 space-y-4">
                <ToggleRow
                    title="Solicitar confirmação do agendamento?"
                    description="Ajuda a reduzir faltas com confirmação prévia."
                    checked={requireConfirmation}
                    onChange={setRequireConfirmation}
                    disabled={!canEditAgendaSettings}
                />

                {requireConfirmation && (
                    <div className="space-y-3">
                        <div className="form-control">
                            <label className="label" htmlFor="minutesBeforeConfirmation">
                                <span className="label-text">Tempo antes do agendamento para confirmação (minutos)</span>
                            </label>
                            <input
                                type="number"
                                id="minutesBeforeConfirmation"
                                value={minutesBeforeConfirmation}
                                onChange={(e) => setMinutesBeforeConfirmation(parseInt(e.target.value))}
                                className="input input-bordered w-full"
                                min="1"
                                disabled={!canEditAgendaSettings}
                            />
                            <span className="text-xs text-base-content/60">
                                Defina em quantos minutos antes o cliente deve confirmar.
                            </span>
                        </div>

                        <div className="rounded-lg border border-base-200/70 p-3">
                            <ToggleRow
                                title="Enviar confirmação via WhatsApp?"
                                description="Mensagem automática com link de confirmação."
                                checked={sendWhatsapp}
                                onChange={setSendWhatsapp}
                                disabled={!canEditAgendaSettings}
                            />
                        </div>
                    </div>
                )}
            </div>

            <div className="mt-6 flex justify-end">
                <button
                    className="btn btn-primary shadow-md w-full sm:w-auto min-w-[160px]"
                    type="submit"
                    onClick={submitAdm}
                    disabled={loading || !canEditAgendaSettings}
                >
                    Salvar alterações
                </button>
            </div>
        </div>
    );
};
